/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
// due to import __ from 'ramda/es/__'; being untyped we can't import it properly
// here is what it exports
export default { '@@functional/placeholder': true };
